const SELECTOR = '.port-steptabs';

export default function initPortStepTabs(options = {}) {
    const $elements = $(SELECTOR);

    // Fail fast if this page doesn't use step tabs
    if (!$elements.length) {
        return [];
    }

    return $elements.map(function () {
        return createPortStepTabs($(this), options);
    }).get();
}

function createPortStepTabs($element, options = {}) {
    const state = {
        element: $element,
        onBeforeTabBodyShow: options.onBeforeTabBodyShow,
        clickedTabId: undefined,
        preventNext: false,
        tabsActiveOnlyIfPreviousVisited: !!options.preventJumpAhead
    };

    function getTabTarget($tab) {
        const href = $tab.attr('href');
        const dataTarget = $tab.attr('data-bs-target');

        const target = dataTarget || href;

        if (!target) {
            return null;
        }

        return target.replace('#', '');
    }

    function makeTabActive($tab) {
        $tab.addClass('active');
    }

    function makeTabInactive() {
        state.element.find('ul.step-tabs a.active').removeClass('active');
    }

    function makeBodyActive() {
        state.element.find(`div[id="${state.clickedTabId}"]`).addClass('active');
    }

    function makeBodyInactive() {
        state.element
            .find('.step-tab-content.active, .step-tab-content.show')
            .removeClass('active show');
    }

    function toggleStepTabs(stepElement) {
        let target;
        let $stepElement;

        if (typeof stepElement === 'string') {
            target = stepElement.replace('#', '');

            $stepElement = state.element.find(
                `ul.step-tabs > li a[data-bs-target="#${target}"], ul.step-tabs > li a[href="#${target}"]`
            );
        } else {
            $stepElement = $(stepElement);

            const dataTarget = $stepElement.attr('data-bs-target');
            const href = $stepElement.attr('href');

            target = (dataTarget || href || '').replace('#', '');
        }

        if (!target || !$stepElement.length) {
            return;
        }

        if (
            state.tabsActiveOnlyIfPreviousVisited &&
            $stepElement.parent().hasClass('disabled')
        ) {
            return;
        }

        state.element.find('div.step-tab-content').triggerHandler('before.tabBody.show');

        if (state.preventNext) {
            return;
        }

        state.clickedTabId = target;

        // Clear ALL active tab links inside this widget
        state.element
            .find('ul.step-tabs > li > a')
            .removeClass('active');

        // Activate selected desktop tab
        $stepElement.addClass('active');

        // Clear ALL active/show tab bodies inside this widget
        state.element
            .find('.step-tab-content, .tab-pane')
            .removeClass('active show');

        // Activate selected body
        state.element
            .find(`#${target}`)
            .addClass('active show');

        // Sync mobile dropdown
        state.element
            .find('#steps-select')
            .val(target);

        if (state.tabsActiveOnlyIfPreviousVisited) {
            $stepElement.closest('li').next().removeClass('disabled');
        }
    }

    function scrollTop() {
        const $stepTabs = $('.port-steptabs');
        const headerHeight = $('.port-navbar').outerHeight() || 0;

        if ($stepTabs.length) {
            const top = $stepTabs.offset().top - headerHeight - 10;

            $(document.scrollingElement || document.documentElement)
                .stop(true)
                .animate({
                    scrollTop: top
                }, 300);
        }
    }

    function showNext() {
        const $currentTab = state.element
            .find(`ul.step-tabs > li a[data-bs-target="#${state.clickedTabId}"], ul.step-tabs > li a[href="#${state.clickedTabId}"]`)
            .parent('li');

        const $nextTab = $currentTab.next('li').find('a');

        if ($nextTab.length) {
            toggleStepTabs($nextTab);
        }

        scrollTop();
    }

    function bindEvents() {
        state.element.on('click', 'ul.step-tabs > li a', function (e) {
            e.preventDefault();

            const $stepElement = $(e.currentTarget);

            if (
                state.tabsActiveOnlyIfPreviousVisited &&
                $stepElement.parent().hasClass('disabled')
            ) {
                return;
            }

            toggleStepTabs($stepElement);
        });

        state.element.on('change', 'select', function () {
            toggleStepTabs($(this).val());
        });

        state.element.find('div.step-tab-content').on('before.tabBody.show', function () {
            if (typeof state.onBeforeTabBodyShow === 'function') {
                state.onBeforeTabBodyShow();
            }
        });

        state.element.on('click', '.next-tab', function (e) {
            e.preventDefault();
            showNext();            
        })        

        const $form = state.element.find('form');

        if ($form.length) {
            $form.on('reset', function () {
                const $firstTab = state.element.find('ul.step-tabs > li a').first();

                toggleStepTabs($firstTab);

                if (state.tabsActiveOnlyIfPreviousVisited) {
                    $firstTab.parent().nextAll(':not(:first)').addClass('disabled');
                }
            });

            $form.on('keypress', ':input:not(textarea)', function (e) {
                if (e.keyCode !== 13) {
                    return;
                }

                e.preventDefault();

                const $activeTab = state.element.find('ul.step-tabs > li:has(a.active)');

                if ($activeTab.next('li').length === 0) {
                    $form.trigger('submit');
                }
            });
        }
    }

    function init() {
        const $firstTab = state.element.find('ul.step-tabs > li a.active').first();

        if (!$firstTab.length) {
            return;
        }

        state.clickedTabId = getTabTarget($firstTab);

        bindEvents();

        if (state.tabsActiveOnlyIfPreviousVisited) {
            $firstTab.parent().nextAll(':not(:first)').addClass('disabled');
        }
    }

    init();

    return {
        showNext,
        goToStep: toggleStepTabs,
        scrollTop,
        setPreventNext(value) {
            state.preventNext = !!value;
        }
    };
}